export const patentTableOfClusterDetail = {
    singleSort: '※項目をクリックすると単項目で並べ替えができます。',
    ipcCodeAreaText: 'IPCコードで絞り込む',
    userInputPlaceholder: 'キーワードを入力してください',
    searchAll: 'すべて検索',
    clusterId: 'クラスタID',
    publicationNumber: '公開番号/特許番号',
    mainIpc: '筆頭IPC',
    otherIpc: 'その他のIPC',
    title: '発明の名称',
    patentOwner: '特許出願保有企業',
    inventor: '発明者',
    factorLoadQuantity: '因子負荷量',
    forwardCitations: '被引用数',
    applicationYear: '出願年',
    materialPatent: '重要特許'
}
